import { useState, useEffect, useRef } from 'react';
import { AppConstants } from '../../../constants/AppConstants';
import { DateTimeUtil } from '../../../utils/DateTimeUtil';
import classes from './ReviewCards.module.css';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';
import Moment from 'react-moment';

export const ReviewCards = ({ review, individualSkillsFlag }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textRef = useRef(null);
  const timeZone = DateTimeUtil.getPreferredTimeZoneForUser();

  const checkOverflow = () => {
    const element = textRef.current;
    if (element) {
      const isOverflowing = element.scrollHeight > element.clientHeight;
      setIsOverflowed(isOverflowing);
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [isExpanded]);

  return (
    <div className={classes.reviewContainer}>
      <div className={classes.profileImageSection}>
        {review.reviewerProfileImagePath ? (
          <div className={classes.reviewInitials}>
            <img
              src={review.reviewerProfileImagePath}
              className={classes.profilePicture}
              alt="user_profile"
            />
          </div>
        ) : (
          <div className={classes.reviewInitials}>
            {review.reviewerNameInitials}
          </div>
        )}
        <div>
          <p className={classes.reviewedByName}>{review.reviewedByName}</p>
          <p
            className={`${classes.reviewComment} ${
              isExpanded ? classes.expanded : ''
            }`}
            ref={textRef}
          >
            {review.review}
          </p>
          {(isOverflowed || isExpanded) && (
            <button
              className={classes.readMoreButton}
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? 'Read Less' : 'Read More'}
            </button>
          )}
          <div className={classes.starSection}>
            {AppConstants.rateNudge5starArray.map((value) => (
              <span key={value} className={classes.ratingStars}>
                {value <= review.rating ? <AiFillStar /> : <AiOutlineStar />}
              </span>
            ))}
            <p className={`${classes.dateText} ${classes.hideDesktopDate}`}>
              {' '}
              |{' '}
              <Moment
                format={AppConstants.competitionDatesNewDateFormat}
                tz={timeZone}
              >
                {review.reviewDate.replace(' ', 'T') + 'Z'}
              </Moment>{' '}
              {timeZone === AppConstants.utcTimezone &&
                `(${review.preferredTimeZone})`}
            </p>
          </div>
          <p className={`${classes.dateText} ${classes.hideMobileDate}`}>
            <Moment
              format={AppConstants.competitionDatesNewDateFormat}
              tz={timeZone}
            >
              {review.reviewDate.replace(' ', 'T') + 'Z'}
            </Moment>{' '}
            {timeZone === AppConstants.utcTimezone &&
              `(${review.preferredTimeZone})`}
          </p>
        </div>
      </div>
    </div>
  );
};
